import { h, r as registerInstance, c as createEvent, H as Host, g as getElement } from './index-1d3c5472.js';

const patternlibHeaderPortalCss = "*,::before,::after{box-sizing:border-box;border-width:0;border-style:solid;border-color:var(--color-steel-200)}::before,::after{--tw-content:''}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-0.25em}sup{top:-0.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type='search']{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:var(--color-steel-400)}input::placeholder,textarea::placeholder{opacity:1;color:var(--color-steel-400)}button,[role=\"button\"]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,::before,::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}.fixed{position:fixed}.sticky{position:sticky}.ml-\\[224px\\]{margin-left:224px}.block{display:block}.flex{display:flex}.grid{display:grid}.hidden{display:none}.h-full{height:100%}.w-full{width:100%}.w-\\[124px\\]{width:124px}.transform{transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-pointer{cursor:pointer}.resize{resize:both}.grid-flow-col{grid-auto-flow:column}.items-center{align-items:center}.justify-end{justify-content:flex-end}.gap-\\[48px\\]{gap:48px}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.bg-white{background-color:var(--color-white)}.p-\\[24px\\]{padding:24px}.px-\\[20px\\]{padding-left:20px;padding-right:20px}.px-\\[24px\\]{padding-left:24px;padding-right:24px}.pb-\\[96px\\]{padding-bottom:96px}.text-left{text-align:left}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}:host{display:block;--doc-height:100vh}.header-container{width:100%;background-color:var(--color-white);box-sizing:border-box;-moz-user-select:none;-webkit-user-select:none;user-select:none}.header-container.sticky{position:fixed;top:0;left:0;z-index:50}.header-container .partner-logo-devider{width:2px;height:44px;background-color:var(--color-steel-200);margin-right:var(--spacing-m)}.header-container .portal-name{font-family:var(--copytext-font-family-bold);font-size:var(--copytext-font-size);color:var(--color-black)}.header-container .menu-button{border:none;outline:none;background:none;padding:0;display:flex;justify-content:center;align-items:center;cursor:pointer}.header-container .menu-button .bar1,.header-container .menu-button .bar2{transition:0.3s;transform-origin:center}.header-container .menu-button.mobile-menu-open .bar1{transform:rotate(45deg) translate(-8px, 8px)}.header-container .menu-button.mobile-menu-open .bar2{transform:rotate(-45deg) translate(-8px, -8px)}.header-container .mobile-menu{position:relative;background-color:var(--color-steel-100);z-index:50;height:calc(var(--doc-height) - 70px)}.header-container .mobile-menu ul{list-style-type:none;margin:0;padding:0}.header-container .mobile-menu li{display:flex;justify-content:flex-start;flex-direction:column;margin:0;padding:0;font-family:var(--copytext-font-family-bold);font-size:var(--copytext-font-size)}.header-container .mobile-menu .mobile-menu-tabitem-wrapper{border-bottom:1px solid var(--color-steel-400)}.header-container .mobile-menu .mobile-menu-tabitem-wrapper.subitem{background-color:var(--color-steel-200)}.header-container .mobile-menu .mobile-menu-expand-subitems-icon{display:flex;justify-content:center;align-items:center;width:100%;height:80px;cursor:pointer}.header-container .mobile-menu .mobile-menu-tabitem,.header-container .mobile-menu .mobile-menu-subitem,.header-container .mobile-menu .mobile-menu-sub-subitem{display:flex;justify-content:flex-start;align-items:center;height:80px;padding-right:12px;overflow:hidden;cursor:pointer}.header-container .mobile-menu .mobile-menu-tabitem span,.header-container .mobile-menu .mobile-menu-subitem span,.header-container .mobile-menu .mobile-menu-sub-subitem span{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.header-container .mobile-menu .mobile-menu-sub-subitem{background-color:var(--color-steel-300);border-bottom:1px solid var(--color-steel-400);padding:0 24px 0 60px}.header-container .tabitem-menu{position:relative;background-color:var(--color-steel-100);width:100%;z-index:50;height:calc(var(--doc-height) - 70px)}@media (min-width: 768px){.header-container .tabitem-menu{height:calc(var(--doc-height) - 70px)}}.header-container .tabitem-menu ul{list-style-type:none;margin:0;padding:0}.header-container .tabitem-menu li{display:flex;justify-content:flex-start;flex-direction:column;margin:0;padding:0;font-family:var(--headline-font-family);font-size:var(--h4-font-size)}.header-container .tabitem-menu .tabitem-menu-tabitem-wrapper{display:flex;width:224px;padding:0 0 24px 0;cursor:pointer}.header-container .tabitem-menu .tabitem-menu-tabitem-wrapper .tabitem-menu-tabitem-underline{background-image:linear-gradient(to bottom, transparent 20%, var(--color-black) 21%);background-position:0 1em;background-repeat:no-repeat;background-size:0% 4px;transition:background-size 0.5s ease-in-out;text-transform:uppercase;line-height:44px}.header-container .tabitem-menu .tabitem-menu-tabitem-wrapper .tabitem-menu-tabitem-underline:hover{background-size:100% 4px;transition-delay:0s}.header-container .tabitem-menu .tabitem-menu-subitem-container{display:flex}.header-container .tabitem-menu .tabitem-menu-subitem-container:hover .tabitem-menu-tabitem-underline{background-size:100% 4px;transition-delay:0s}.header-container .tabitem-menu .tabitem-menu-subitem-container .tabitem-menu-sub-subitem-container{position:relative;display:contents}.header-container .tabitem-menu .tabitem-menu-subitem-container .tabitem-menu-sub-subitem-container ul{display:none;flex-direction:column;position:absolute;left:448px;width:100%}.header-container .tabitem-menu .tabitem-menu-subitem-container .tabitem-menu-sub-subitem-container li{font-size:24px}.header-container .tabitem-menu .tabitem-menu-subitem-container .tabitem-menu-sub-subitem-container .tabitem-menu-sub-subitem-wrapper{display:flex;justify-content:flex-start;align-items:center;padding:0 0 24px 48px;cursor:pointer;width:100%;min-height:48px}.header-container .tabitem-menu .tabitem-menu-subitem-container .tabitem-menu-sub-subitem-container .tabitem-menu-sub-subitem-wrapper:hover{font-family:var(--headline-font-family)}.header-container .tabitem-menu .tabitem-menu-subitem-container:hover .tabitem-menu-sub-subitem-container ul{display:inline-flex}.header-wrapper{position:relative;grid-template-columns:auto 1fr;min-height:70px}@media (min-width: 1280px){.header-wrapper{min-height:90px}}.header-wrapper.portal{grid-template-columns:auto auto}@media (min-width: 768px){.header-wrapper{gap:var(--spacing-xl)}.header-wrapper.portal{grid-template-columns:auto auto 1fr}}@media (min-width: 1280px){.header-wrapper{grid-template-columns:auto 1fr auto}.header-wrapper.portal{grid-template-columns:auto auto 1fr auto}}::slotted(patternlib-main-navigation){padding-top:var(--spacing-4);padding-bottom:var(--spacing-4)}.burger-wrapper{position:relative;display:inline-block}.burger-wrapper patternlib-badge{position:absolute;top:0px;right:-10px}@media (min-width: 768px){.tablet\\:flex{display:flex}}@media (min-width: 1280px){.desktop\\:block{display:block}.desktop\\:hidden{display:none}.desktop\\:w-\\[165px\\]{width:165px}.desktop\\:px-\\[120px\\]{padding-left:120px;padding-right:120px}}";

const logo = (h("div", { innerHTML: `
  <svg version="1.1" id="Brand" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1000 124">
    <path
      d="M238.9,95.2h31.4V124h-89.9V0h89v28.8h-30.6v19.8h27.9v26.1h-27.9V95.2z M101.3,124h59.3V0h-59.3V124z M58.4,0H0l0,124h85.4
            V90.8h-27V0z M654.1,74.6H682V48.5h-27.9V28.8h30.6V0h-89v124h89.9V95.2h-31.5V74.6z M423.4,90.7c0,16.2-9.5,26.8-25.7,30.7
            c-7.1,1.7-18.6,2.6-29,2.6h-80.5V0h80c10.2,0,21.4,0.9,28.4,2.6c15.8,3.9,25.1,14.5,25.1,30.7c0,14.9-8.8,25.1-20,28.4
            C413.7,64.4,423.4,75,423.4,90.7 M344.7,50.3h8.1c10.8,0,14.4-5.4,14.4-13s-3.6-13-14.4-13h-8.1V50.3z M369,86.3
            c0-8.1-3.7-13.5-15.3-13.5h-9v27h9C365.4,99.7,369,94.3,369,86.3 M517,45.8h-19.8V0h-58.4v124h58.4V76.4H517V124h58.4V0H517V45.8z
            M967.9,72.3c15.3-7,22.1-18.6,22.1-34.4c0-18.4-11-30.4-29.4-34.9c-8.1-1.9-21.2-3-33-3h-71.9v124h55.7V84.5h5l21.1,39.5h62.5
            L967.9,72.3z M919.5,58.4h-8.1V28.8h8.1c10.8,0,14.4,5.4,14.4,14.8C933.9,53,930.3,58.4,919.5,58.4z M815.4,72.3
            c15.3-7,22.1-18.6,22.1-34.4c0-18.4-11-30.4-29.4-34.9c-8.1-1.9-21.2-3-33-3h-71.9v124h55.7V84.5h5l21.1,39.5h62.5L815.4,72.3z
            M766.9,58.4h-8.1V28.8h8.1c10.8,0,14.4,5.4,14.4,14.8C781.3,53,777.7,58.4,766.9,58.4z"
      fill="#000000"
    />
  </svg>
  ` }));
const PatternlibHeaderPortal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.lhSticky = createEvent(this, "lhSticky", 7);
    this.tabClick = createEvent(this, "lhTabClick", 7);
    this.mobileSearch = createEvent(this, "lhMobileSearch", 7);
    this.mobileEnterPress = createEvent(this, "lhMobileEnterPress", 7);
    this.clickBrandLogo = createEvent(this, "lhClickBrandLogo", 7);
    this.isStickyAndMenuisOpen = false;
    this.initialRender = true;
    this.handleMenuClick = () => {
      this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
      if (this.sticky) {
        this.isSticky = true;
        this.isStickyAndMenuisOpen = true;
        this.lhSticky.emit({ isSticky: this.isSticky });
      }
      this.fixBodyPosition();
    };
    this.handleTabClick = (itemId, index2, index3) => async () => {
      if (itemId != undefined && index2 === undefined && index3 === undefined) {
        this.tabClick.emit({ itemId: itemId });
        this.lastOpendTab = itemId;
        await this.tabElement.setTabToActive(itemId);
        this.tabItemMenuIsOpen = false;
        this.mobileMenuIsOpen = false;
        this.tabItemIndex = undefined;
        this.fixBodyPosition();
      }
      else if (itemId != undefined && index2 != undefined && index3 === undefined) {
        this.tabClick.emit({ itemId: itemId, subitemId: index2 });
        this.lastOpendTab = itemId;
        this.tabItemMenuIsOpen = false;
        this.mobileMenuIsOpen = false;
        this.tabItemIndex = undefined;
        this.fixBodyPosition();
      }
      else if (itemId != undefined && index2 != undefined && index3 != undefined) {
        this.tabClick.emit({ itemId: itemId, subitemId: index2, subSubitemId: index3 });
        this.lastOpendTab = itemId;
        this.tabItemMenuIsOpen = false;
        this.mobileMenuIsOpen = false;
        this.tabItemIndex = undefined;
        this.fixBodyPosition();
      }
    };
    this.handleCloseTabItemMenu = async () => {
      await this.closeMenus();
      this.fixBodyPosition();
    };
    this.handleToggleSubitems = (index, index2) => () => {
      if (index != undefined && index2 === undefined) {
        this.tabItems = this.tabItems.map((tab, i) => {
          if (i === index) {
            tab.subitemsAreCollapsed = !tab.subitemsAreCollapsed;
          }
          else {
            tab.subitemsAreCollapsed = true;
          }
          return tab;
        });
      }
      else if (index != undefined && index2 != undefined) {
        if (this.subItemIndex === index + index2) {
          this.subItemIndex = undefined;
        }
        else {
          this.subItemIndex = index + index2;
        }
      }
    };
    this.handleBrandLogoClick = () => {
      this.clickBrandLogo.emit();
    };
    this.padding = undefined;
    this.portalName = '';
    this.sticky = undefined;
    this.stickyByDefault = undefined;
    this.brandLogo = undefined;
    this.moreSlotWidth = 'auto';
    this.mobileMenuIsOpen = false;
    this.usePadding = false;
    this.isSticky = false;
    this.tabItemMenuIsOpen = false;
    this.tabItems = [];
    this.tabItemIndex = undefined;
    this.subItemIndex = undefined;
    this.unseenNotificationCount = 0;
  }
  /*
    * watch 'portalName' and set it if it has changed or has been
      provided later (e.g. when translation is loaded)
  */
  updateHasPortalName() {
    this.hasPortalName = this.portalName !== '' && this.portalName !== null;
    this.hasPortalNameOrPartnerLogo = this.hasPortalName || this.hasPartnerLogoSlot;
  }
  updateUnseenNotificationCount(evt) {
    if (evt.detail !== '') {
      this.unseenNotificationCount = evt.detail;
    }
  }
  /*
    * Sets the innerHeight to the current height of the window
      and sets this height as a property for the CSS File.
  */
  handleResize() {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
  }
  async componentWillLoad() {
    this.hasPartnerLogoSlot = this.hostElement.querySelector('[slot="partner-logo"]') !== null;
    this.tabElement = this.hostElement.querySelector('patternlib-tabs');
    this.hasPortalName = this.portalName !== '';
    this.hasPortalNameOrPartnerLogo = this.hasPortalName || this.hasPartnerLogoSlot;
    this.offsetTop = this.hostElement.offsetTop;
    this.hasMoreSlot = this.hostElement.querySelector('[slot="more"]') !== null;
    this.hasSearchSlot = this.hostElement.querySelector('[slot="search"]') !== null;
    if (this.tabElement != null) {
      this.tabElement.setAttribute('padding-top', '9px');
    }
    this.tabItems = Array.from(this.hostElement.querySelectorAll('patternlib-tabs-item'));
  }
  // Fix Firefox bug where initial offsetTop returns a negative value and force to set tab to active to check scroll overflow again.
  async componentDidLoad() {
    this.offsetTop = this.hostElement.offsetTop;
    this.handleResize();
    let i = 0;
    for (const tab of this.tabItems) {
      if (tab.active) {
        await this.tabElement.setTabToActive(i);
        this.lastOpendTab = i;
      }
      i++;
    }
  }
  componentDidUpdate() {
    this.offsetTop = this.hostElement.offsetTop;
  }
  windowScroll() {
    const isOpen = this.mobileMenuIsOpen || this.tabItemMenuIsOpen;
    if (this.sticky) {
      if (window.pageYOffset > this.offsetTop && isOpen === false) {
        this.isSticky = true;
        this.lhSticky.emit({ isSticky: this.isSticky });
      }
      else if (window.pageYOffset <= this.offsetTop && isOpen === false) {
        this.isSticky = false;
        this.lhSticky.emit({ isSticky: this.isSticky });
      }
    }
    if (isOpen === false) {
      this.scrollPosition = window.pageYOffset;
    }
  }
  handleTabChange(e) {
    const itemId = e.detail.itemId;
    if (this.initialRender == false) {
      this.tabItems.map((tab, i) => {
        if (i === itemId || tab.itemId === itemId) {
          const index = i;
          if (this.mobileMenuIsOpen === false) {
            if (this.tabItems[index].subitems != undefined) {
              if (this.tabItemMenuIsOpen === false && this.tabItemIndex != index) {
                this.tabItemIndex = index;
                this.tabItemMenuIsOpen = true;
                if (this.sticky) {
                  this.isSticky = true;
                  this.isStickyAndMenuisOpen = true;
                  this.lhSticky.emit({ isSticky: this.isSticky });
                }
                this.fixBodyPosition();
              }
              else if (this.tabItemMenuIsOpen && this.tabItemIndex != index) {
                this.tabItemIndex = index;
              }
              else if (this.tabItemMenuIsOpen && this.tabItemIndex === index) {
                this.tabItemMenuIsOpen = false;
                this.tabItemIndex = undefined;
                this.fixBodyPosition();
              }
            }
            else {
              this.tabItemMenuIsOpen = false;
              this.tabItemIndex = undefined;
              this.fixBodyPosition();
              if (this.lastOpendTab != itemId) {
                this.tabClick.emit({ itemId: itemId });
                this.lastOpendTab = itemId;
              }
            }
          }
          else {
            this.mobileMenuIsOpen = false;
            this.fixBodyPosition();
          }
        }
      });
    }
    this.initialRender = false;
  }
  async handleEscapePress(e) {
    if (e.key === 'Escape') {
      if (this.mobileMenuIsOpen && this.tabItemMenuIsOpen === false) {
        this.handleMenuClick();
      }
      else if (this.mobileMenuIsOpen === false && this.tabItemMenuIsOpen) {
        await this.handleCloseTabItemMenu();
      }
    }
  }
  handleEnterPress(e) {
    const value = e.detail;
    this.mobileEnterPress.emit({ value: value });
  }
  /**
   * Provide a method to monitor if the component gets clicked outside and close menu.
   */
  handleWindowClick(e) {
    if (this.mobileMenuIsOpen) {
      if (e.target != this.hostElement) {
        this.mobileMenuIsOpen = false;
      }
    }
  }
  /**
   * @deprecated Set the prop screenSize from outside (e.g. ResizeObserver)
   *
   * Will be removed with 3.0. Does nothing.
   *
   * @param {ScreenSize} _screen - The size of the Screen
   * @param _height
   */
  async setScreenSize(_screen, _height) {
    // this.screenSize = screen;
    // this.screenHeight = height;
  }
  fixBodyPosition() {
    const isSticky = this.isSticky || this.stickyByDefault;
    // Fix the body's position if the mobile menu is open and remove the property if mobile menu get closed
    if (this.isStickyAndMenuisOpen === false) {
      if ((this.mobileMenuIsOpen && isSticky) || (this.tabItemMenuIsOpen && isSticky)) {
        document.body.style.position = 'fixed';
      }
      else {
        document.body.style.position = '';
        // Set the scroll position back to last know position
        window.scrollTo(0, this.scrollPosition);
      }
    }
    else if (this.isStickyAndMenuisOpen) {
      if ((this.mobileMenuIsOpen && isSticky) || (this.tabItemMenuIsOpen && isSticky)) {
        document.body.style.position = 'fixed';
      }
      else {
        document.body.style.position = '';
        this.isStickyAndMenuisOpen = false;
        // Set the scroll position back to last know position
        if (this.scrollPosition <= this.offsetTop || this.scrollPosition === undefined) {
          this.isSticky = false;
          this.lhSticky.emit({ isSticky: this.isSticky });
          // Try to scroll to offsetTop
          window.scrollTo(0, this.offsetTop);
        }
        else {
          window.scrollTo(0, this.scrollPosition);
        }
      }
    }
  }
  async closeMenus() {
    if (this.tabItemIndex != this.lastOpendTab) {
      await this.tabElement.setTabToActive(this.lastOpendTab);
    }
    this.tabItemMenuIsOpen = false;
    this.mobileMenuIsOpen = false;
    this.tabItemIndex = undefined;
  }
  render() {
    const mobileMenuTabitemWrapperClassName = 'mobile-menu-tabitem-wrapper';
    const headerClass = {
      'header-container': true,
      'sticky': this.isSticky || this.stickyByDefault,
    };
    const headerWrapperClasses = {
      'header-wrapper grid items-center h-full': true,
      'portal': this.hasPortalNameOrPartnerLogo,
      'px-[20px] desktop:px-[120px]': this.usePadding,
    };
    const navigationWrapperClasses = {
      'hidden desktop:block': true,
      'px-[20px] desktop:px-[120px]': this.usePadding,
    };
    const portalNameClass = {
      'portal-name': true,
    };
    const partnerLogoDeviderClass = {
      'partner-logo-devider': true,
    };
    const menuButtonClass = {
      'menu-button': true,
      'mobile-menu-open': this.mobileMenuIsOpen,
    };
    const mobileMenuClass = {
      'mobile-menu': true,
    };
    const mobileMenuTabitemWrapperClass = {
      [mobileMenuTabitemWrapperClassName]: true,
    };
    const mobileMenuTabitemClass = {
      'mobile-menu-tabitem': true,
      'overflow-hidden': true,
    };
    const mobileMenuExpandSubitemsIconClass = {
      'mobile-menu-expand-subitems-icon': true,
    };
    const mobileMenuTabitemWrapperSubitemsClass = {
      [mobileMenuTabitemWrapperClassName]: true,
      subitem: true,
    };
    const mobileMenuSubSubitemClass = {
      'mobile-menu-subitem': true,
    };
    const mobileMenuTabitemWrapperSubSubitemsClass = {
      [mobileMenuTabitemWrapperClassName]: true,
      'mobile-menu-sub-subitem': true,
    };
    const tabitemMenuClass = {
      'tabitem-menu': true,
    };
    const tabitemMenuTabitemWrapperClass = {
      'tabitem-menu-tabitem-wrapper': true,
    };
    const tabitemMenuTabitemUnderlineClass = {
      'tabitem-menu-tabitem-underline': true,
    };
    const tabitemMenuSubitemContainerClass = {
      'tabitem-menu-subitem-container': true,
    };
    const tabitemMenuSubSubitemContainerClass = {
      'tabitem-menu-sub-subitem-container': true,
    };
    const tabitemMenuSubSubitemWrapperClass = {
      'tabitem-menu-sub-subitem-wrapper': true,
    };
    const headerContainerStyles = {
      boxShadow: this.isSticky || this.stickyByDefault ? 'var(--shadow-elevation-basic)' : undefined,
    };
    const headerStyles = {
      padding: !this.usePadding ? this.padding : undefined,
    };
    const partnerLogoDeviderStyles = { marginLeft: this.hasPortalName ? 'var(--spacing-m)' : '0px' };
    const mobileMenuWrapperStyles = { gridTemplateRows: this.hasSearchSlot ? '80px 1fr 80px' : '1fr 80px' };
    const moreSlotStyles = { width: this.moreSlotWidth };
    const menuIcon = (h("button", { class: menuButtonClass, onClick: this.handleMenuClick }, this.mobileMenuIsOpen ? (
    // "close" icon (rotation of lines with CSS transform)
    h("svg", { width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("rect", { x: "15", y: "23", width: "50", height: "2", fill: "black", class: "bar1" }), h("rect", { x: "15", y: "40", width: "50", height: "2", fill: "black", class: "bar2" }))) : (
    // hamburger icon
    h("div", { class: "burger-wrapper" }, h("svg", { width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("rect", { x: "15", y: "23", width: "34", height: "2", fill: "black", class: "bar1" }), h("rect", { x: "15", y: "40", width: "34", height: "2", fill: "black", class: "bar2" })), this.unseenNotificationCount > 0 ? (h("patternlib-badge", { "badge-size": "responsive", value: this.unseenNotificationCount < 100 ? this.unseenNotificationCount.toString() : '99+' })) : null))));
    const closeIcon = (h("button", { class: menuButtonClass, onClick: this.handleCloseTabItemMenu }, h("svg", { width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { d: "M15.5 48.5L48.5 15.5", stroke: "black", "stroke-width": "2" }), h("path", { d: "M48.5 48.5L15.5 15.5", stroke: "black", "stroke-width": "2" }))));
    const mobileMenu = (h("div", { role: "navigation", class: mobileMenuClass }, h("div", { class: "grid h-full", style: mobileMenuWrapperStyles }, this.hasSearchSlot && (h("div", { class: "flex items-center h-full px-[24px] bg-white" }, h("div", { class: "w-full" }, h("patternlib-searchbox", { type: "mobile" })))), h("div", { class: "overflow-auto" }, h("ul", null, this.tabItems
      .filter(x => x.show)
      .map((tabItem, index) => {
      let _subitems;
      if (tabItem.subitems != undefined) {
        _subitems = JSON.parse(tabItem.subitems);
      }
      const itemId = tabItem.itemId != undefined ? tabItem.itemId : index;
      const collapseSubitemsIconStyles = {
        transform: tabItem.subitemsAreCollapsed === false ? 'rotate(180deg)' : 'rotate(360deg)',
      };
      return (h("li", null, h("div", { class: mobileMenuTabitemWrapperClass }, h("a", null, h("div", { class: "grid px-[24px]", style: { gridTemplateColumns: _subitems != undefined ? '1fr 64px' : '1fr' } }, h("div", { class: mobileMenuTabitemClass, onClick: this.handleTabClick(itemId) }, h("span", null, tabItem.label)), _subitems != undefined && (h("div", { class: mobileMenuExpandSubitemsIconClass, style: collapseSubitemsIconStyles, onClick: this.handleToggleSubitems(index) }, h("patternlib-icon", { "icon-name": "arrow-down", size: "44px" })))))), _subitems != undefined && tabItem.subitemsAreCollapsed === false && (h("ul", null, _subitems.map((item, index2) => {
        const collapseSubSubitemsIconStyles = {
          transform: this.subItemIndex === index + index2 ? 'rotate(180deg)' : 'rotate(360deg)',
        };
        const subitemId = item.itemId || index2;
        return (h("li", null, h("div", { class: mobileMenuTabitemWrapperSubitemsClass }, h("a", null, h("div", { class: "grid px-[24px]", style: { gridTemplateColumns: _subitems[index2].items != undefined ? '1fr 64px' : '1fr' } }, h("div", { class: mobileMenuSubSubitemClass, onClick: this.handleTabClick(itemId, subitemId) }, h("span", null, item.label)), _subitems[index2].items != undefined && (h("div", { class: mobileMenuExpandSubitemsIconClass, style: collapseSubSubitemsIconStyles, onClick: this.handleToggleSubitems(index, index2) }, h("patternlib-icon", { "icon-name": "arrow-down", size: "44px" })))))), _subitems[index2].items != undefined && this.subItemIndex === index + index2 && (h("ul", null, _subitems[index2].items.map((item, index3) => {
          const subSubitemId = item.itemId || index3;
          return (h("li", null, h("a", null, h("div", { class: mobileMenuTabitemWrapperSubSubitemsClass, onClick: this.handleTabClick(itemId, subitemId, subSubitemId) }, h("span", null, item.label)))));
        })))));
      })))));
    }), h("slot", null))), h("div", { class: "bg-white px-[24px]" }, h("div", { class: "flex justify-end items-center bg-white h-full" }, h("div", { style: moreSlotStyles }, h("slot", { name: "more" })))))));
    const tabItemMenu = (h("div", { role: "navigation", class: tabitemMenuClass }, h("div", { class: "flex justify-end p-[24px]" }, closeIcon), h("div", { class: "h-full pb-[96px] ml-[224px]" }, h("div", { class: "text-left" }, h("ul", null, this.tabItems.map((tabItem, index) => {
      if (index === this.tabItemIndex) {
        const _subitems = JSON.parse(tabItem.subitems);
        const itemId = tabItem.itemId != undefined ? tabItem.itemId : index;
        return (h("li", null, h("div", { class: tabitemMenuTabitemWrapperClass, onClick: this.handleTabClick(itemId) }, h("a", null, h("span", { class: tabitemMenuTabitemUnderlineClass }, tabItem.label))), h("ul", null, _subitems.map((item, index2) => {
          const subitemId = item.itemId || index2;
          return (h("li", null, h("div", { class: tabitemMenuSubitemContainerClass }, h("div", { class: tabitemMenuTabitemWrapperClass, onClick: this.handleTabClick(itemId, subitemId) }, h("a", null, h("span", { class: tabitemMenuTabitemUnderlineClass }, item.label))), _subitems[index2].items != undefined && (h("div", { class: tabitemMenuSubSubitemContainerClass }, h("ul", null, _subitems[index2].items.map((item, index3) => {
            const subSubitemId = item.itemId || index3;
            return (h("li", null, h("div", { class: tabitemMenuSubSubitemWrapperClass, onClick: this.handleTabClick(itemId, subitemId, subSubitemId) }, h("a", null, item.label))));
          })))))));
        }))));
      }
    }))))));
    const additionals = this.hasMoreSlot && this.hasSearchSlot ? (h("div", { class: "grid grid-flow-col gap-[48px]" }, h("slot", { name: "search" }), h("slot", { name: "more" }))) : this.hasMoreSlot ? (h("slot", { name: "more" })) : this.hasSearchSlot ? (h("slot", { name: "search" })) : null;
    return (h(Host, null, h("header", { class: headerClass, style: headerContainerStyles }, h("div", { class: headerWrapperClasses, style: headerStyles }, h("div", { class: "cursor-pointer w-[124px] desktop:w-[165px]" }, !this.brandLogo ? (h("div", { onClick: this.handleBrandLogoClick }, logo)) : (h("patternlib-image", { src: this.brandLogo, alt: "Brand Logo", onClick: this.handleBrandLogoClick }))), this.hasPortalNameOrPartnerLogo && (h("div", { class: "hidden tablet:flex items-center w-full h-full" }, this.hasPortalName && h("span", { class: portalNameClass }, this.portalName), this.hasPartnerLogoSlot && h("div", { class: partnerLogoDeviderClass, style: partnerLogoDeviderStyles }), this.hasPartnerLogoSlot && h("slot", { name: "partner-logo" }))), h("div", { class: "hidden desktop:block overflow-auto" }, h("slot", { name: "tabs" })), !this.mobileMenuIsOpen && h("div", { class: "hidden desktop:block" }, additionals), h("div", { class: {
        'flex items-center justify-end w-full h-full': true,
        'desktop:hidden': !this.mobileMenuIsOpen,
      } }, menuIcon)), h("div", { class: navigationWrapperClasses, style: headerStyles }, !this.mobileMenuIsOpen && h("slot", null)), this.mobileMenuIsOpen && mobileMenu, this.tabItemMenuIsOpen && tabItemMenu)));
  }
  get hostElement() { return getElement(this); }
  static get watchers() { return {
    "portalName": ["updateHasPortalName"]
  }; }
};
PatternlibHeaderPortal.style = patternlibHeaderPortalCss;

export { PatternlibHeaderPortal as patternlib_header_portal };
